// extracted by mini-css-extract-plugin
export default {"autoTypeWrapper":"AutoTypeWrapper_autoTypeWrapper__dVPxv"};